import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_MovToMp3Converter = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/mov-to-mp3-converter',
			name: 'MOV to MP3 Converter Online — Extract Audio Instantly by Lift',
			description:
				'Convert MOV to MP3 online — upload your MOV file and Lift extracts the audio as MP3 in seconds. High quality, no software needed. Try Lift now!',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/mov-to-mp3-converter#product' },
				{ '@id': 'https://liftapp.ai/mov-to-mp3-converter#howto' },
				{ '@id': 'https://liftapp.ai/mov-to-mp3-converter#faq' },
				{ '@id': 'https://liftapp.ai/mov-to-mp3-converter#why-lift' },
				{ '@id': 'https://liftapp.ai/mov-to-mp3-converter#explore-tools' },
				{ '@id': 'https://liftapp.ai/mov-to-mp3-converter#all-in-one' },
			],
		},
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/mov-to-mp3-converter#product',
			name: 'MOV to MP3 Converter Online',
			description:
				'Extract audio from MOV files and save as MP3. Upload your MOV file, choose MP3 as output, and download the result in seconds.',
			url: 'https://liftapp.ai/mov-to-mp3-converter',
			fileFormat: [
				'audio/mpeg',
				'video/quicktime',
				'video/mp4',
				'video/x-msvideo',
				'video/webm',
				'video/x-matroska',
			],
			memoryRequirements: 'Max file size: 2GB',
			brand: { '@type': 'Brand', name: 'Lift' },
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/mov-to-mp3-converter#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload Your MOV File',
					text: 'Drop in your MOV file or any other supported video format — MP4, AVI, MKV, WEBM, FLV, and more.',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Choose MP3 as Output',
					text: 'Select MP3 from dozens of audio and video output formats — WAV, AAC, FLAC, OGG, MP4, and more are also available.',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Lift Extracts the Audio',
					text: 'Lift processes your MOV file and extracts the audio track with high-fidelity encoding, preserving the original quality.',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download the MP3',
					text: 'Your MP3 file is ready instantly — download it for playback, editing, podcasting, or sharing.',
				},
			],
		},
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/mov-to-mp3-converter#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is the Lift MOV to MP3 Converter?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift MOV to MP3 Converter is an online tool that extracts audio from MOV files and saves it as MP3 in seconds. Upload your MOV file, choose MP3 as output, and download the result.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does the Lift MOV to MP3 Converter work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Upload your MOV file, select MP3 as the output format, and Lift processes the conversion. Your MP3 file is ready to download in seconds.',
					},
				},
				{
					'@type': 'Question',
					name: 'How long does MOV to MP3 conversion take?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Most conversions complete in seconds. Processing time depends on file size, but Lift is optimized to deliver results as fast as possible.',
					},
				},
				{
					'@type': 'Question',
					name: 'Will the extracted MP3 maintain audio quality?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift uses high-fidelity encoding to preserve the original audio quality when extracting and converting from MOV to MP3.',
					},
				},
				{
					'@type': 'Question',
					name: 'Is it safe to convert files with Lift?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift prioritizes your privacy — all files are processed securely and are not stored or shared after conversion. Your converted result is available only to you.',
					},
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/mov-to-mp3-converter#why-lift',
			name: "Why Lift's MOV to MP3 Converter stands out",
			description:
				'High-quality audio extraction, intelligent encoding, cross-platform support, and budget-friendly pricing — Lift delivers professional-grade conversion.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality audio',
					description:
						'AI-powered technology extracts and encodes MP3 audio at the highest quality.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent encoding',
					description:
						'AI tailors the conversion to the source MOV for optimal MP3 output.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description:
						'Available on iOS, Android, and Web for seamless access.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly software with an affordable and intuitive tool.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/images/mov-to-mp3-converter/whyLift.webp',
				name: 'Lift MOV to MP3 Converter delivering high-quality audio',
				description: "Lift's online MOV to MP3 converter in high resolution.",
			},
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/mov-to-mp3-converter#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},
		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/mov-to-mp3-converter#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},
		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'MOV to MP3 Converter',
					item: 'https://liftapp.ai/mov-to-mp3-converter',
				},
			],
		},
	],
};
